import moment from 'moment';

import { menuSetting }          from 'alto-react-canteen/lib/settings';
import { Menu, MenuWithOrders } from 'alto-react-canteen/lib/models';
import Orders                   from 'alto-react-canteen/lib/services/orders';

export const CANTEEN_NAMESPACE = 'canteen';

const LOAD_MENU               = 'LOAD_MENU';
const LOAD_TERMINAL           = 'LOAD_TERMINAL';
const FORGET_MENU             = 'FORGET_MENU';
const UPDATE_MENU             = 'UPDATE_MENU';
const SELECT_CANTEEN          = 'SELECT_CANTEEN';
const SELECT_DATE             = 'SELECT_DATE';
const SELECT_MEAL             = 'SELECT_MEAL';
const DESELECT_MEAL           = 'DESELECT_MEAL';
const START_SAVING_MENU       = 'START_SAVING_MENU';
const FINISH_SAVING_MENU      = 'FINISH_SAVING_MENU';
const SHOW_ORDER_SUMMARY      = 'SHOW_ORDER_SUMMARY';
const HIDE_ORDER_SUMMARY      = 'HIDE_ORDER_SUMMARY';
const FORGET_CANTEEN_DATA     = 'FORGET_CANTEEN_DATA';
const SET_MENU_SAVING_ERROR   = 'SET_MENU_SAVING_ERROR';
const CLEAR_MENU_SAVING_ERROR = 'CLEAR_MENU_SAVING_ERROR';

export function loadMenu(backend, settings, loggedIn) {
  const menuClass = loggedIn ? MenuWithOrders : Menu;
  const setting   = menuSetting(settings);
  const options   = {
    backend,
    settings:     setting,
    startDate:    moment().startOf('day'),
    numberOfDays: setting.numberOfDays
  };

  if (loggedIn) {
    options.clientID = backend.auth.loggedInClient.clientId;
  }

  return { type: LOAD_MENU, payload: menuClass.load(options) };
};

export const updateMenu    = menu => ({ type: UPDATE_MENU, menu });

export const selectCanteen = id   => ({ type: SELECT_CANTEEN, id });
export const selectDate    = date => ({ type: SELECT_DATE, date });
export const selectMeal    = meal => ({ type: SELECT_MEAL, meal });

export const deselectMeal  = (canteenID, date, course) => (
  { type: DESELECT_MEAL, canteenID, date, course }
);

export const startSavingMenu  = () => ({ type: START_SAVING_MENU });
export const finishSavingMenu = () => ({ type: FINISH_SAVING_MENU });
export const showOrderSummary = () => ({ type: SHOW_ORDER_SUMMARY });
export const hideOrderSummary = () => ({ type: HIDE_ORDER_SUMMARY });

export const setMenuSavingError   = error => ({ type: SET_MENU_SAVING_ERROR, error });
export const clearMenuSavingError =    () => ({ type: CLEAR_MENU_SAVING_ERROR      });

function withMenuSavingHandling(dispatch, saveFunction, successFunction) {
  dispatch(startSavingMenu());

  return saveFunction()
    .then(() => {
      dispatch(clearMenuSavingError());
      successFunction();
      dispatch(finishSavingMenu());
    })
    .catch(error => {
      dispatch(setMenuSavingError(error));
      dispatch(finishSavingMenu());
    });
};

export function saveCourseGroup(backend, group) {
  return (dispatch, getState) => {
    const state = getState()[CANTEEN_NAMESPACE];

    const { menu, selectedCanteenID, selectedDate } = state;

    const orders  = menu.forGroup(selectedCanteenID, selectedDate, group).orders();
    const service = new Orders(backend);

    return withMenuSavingHandling(dispatch,
      () => service.orderCourseGroup(selectedCanteenID, selectedDate, group, orders),
      () => dispatch(updateMenu(menu.save(selectedCanteenID, selectedDate, group)))
    );
  };
}

export function cancelCourseGroup(backend, group) {
  return (dispatch, getState) => {
    const state   = getState()[CANTEEN_NAMESPACE];
    const service = new Orders(backend);

    const { menu, selectedCanteenID, selectedDate } = state;

    return withMenuSavingHandling(dispatch,
      () => service.cancelCourseGroup(selectedCanteenID, selectedDate, group, orders),
      () => dispatch(updateMenu(menu.cancel(selectedCanteenID, selectedDate, group)))
    );
  };
}

export function saveMenu(backend) {
  return (dispatch, getState) => {
    const state   = getState()[CANTEEN_NAMESPACE];

    const orders  = state.menu.orders();
    const service = new Orders(backend);

    return withMenuSavingHandling(dispatch,
      () => service.saveAll(orders),
      () => {
        dispatch(updateMenu(state.menu.saveAll()));
        dispatch(hideOrderSummary());
      });
  };
}

export function loadCanteenData(backend, settings, loggedIn) {
  return (dispatch, getState) => {
    const state = getState()[CANTEEN_NAMESPACE];

    if (state.menu) {
      return Promise.resolve([]);
    } else {
      return dispatch(loadMenu(backend, settings, loggedIn))
        .then(() => dispatch(loadTerminal(backend)))
        .then(() => dispatch(resetCanteenAndDateSelection()))
    }
  };
}

export function loadTerminal(backend) {
  return {
    type:    LOAD_TERMINAL,
    payload: backend.auth.isRegisteredTerminal().then(({ terminal }) => terminal)
  };
};

export function resetCanteenAndDateSelection(force = false) {
  return (dispatch, getState) => {
    const state = getState()[CANTEEN_NAMESPACE];

    if (force || !state.selectedCanteenID) {
      const id = state.terminal?.defaultCanteenID || state.menu.canteens.safeFirst()?.id;

      if (id) {
        dispatch(selectCanteen(id));
      }
    }

    if (force || !state.selectedDate) {
      dispatch(selectDate(state.menu.dates.first()));
    }
  };
}

export const forgetMenu        = () => ({ type: FORGET_MENU         });
export const forgetCanteenData = () => ({ type: FORGET_CANTEEN_DATA });
